import { SearchConfig, SearchKey } from "../../../../types/search";

type OptionKeys = Extract<
  SearchKey,
  | "unitCode"
  | "name"
  | "property"
  | "leaseExecutive"
  | "bookingId"
  | "mobileNumber"
  | "email"
  | "businessUnitId"
  | "ownerName"
  | "recordNumber"
>;

export type SearchByOptionsType = SearchConfig<OptionKeys>;

export const searchByOptions: SearchByOptionsType[] = [
  { value: "unitCode", label: "Unit Code", controlType: "text", default: true },
  { value: "name", label: "Name", controlType: "text" },
  { value: "property", label: "Property", controlType: "text" },
  { value: "leaseExecutive", label: "Lease Executive", controlType: "text" },
  { value: "bookingId", label: "Booking ID", controlType: "text" },
  { value: "mobileNumber", label: "Phone", controlType: "text" },
  { value: "email", label: "Email", controlType: "text" },
  { value: "businessUnitId", label: "Business Unit", controlType: "select" },
  { value: "ownerName", label: "Owner", controlType: "select" },
  { value: "recordNumber", label: "ID", controlType: "text" },
];
